//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FreeShipping',
  components: '',
  data () {
    return {
      tier: this.shipping.tier
    }
  },
  props: ['rewards', 'shipping', 'storeDomain', 'currencySymbol'],
  methods: {
    shippingUpdate(type) {
      if(!this.shipping.enable === true) {
        this.shipping.tier = 1;
        this.tier = 1;
      }
      const data = {
        condition: this.shipping.condition,
        countries: this.shipping.countries,
        enable: type === 'status' ? !this.shipping.enable : this.shipping.enable,
        tier: parseInt(this.tier),
        title: this.shipping.title,
        zone: this.shipping.zone
      }

      this.$emit('shipping-update', data)
    }
  },
  mounted () {
  }
}
